/**
 * Сколько секунд прочитанное живёт в браузере без подписчиков. Прошлые дни и месяцы уже не меняются — переключение между ними
 * мгновенное, пока человек в этой вкладке; текущий день и месяц экран перечитывает при каждом входе в период.
 */
export const KEEP_PAST_SECONDS = 4 * 60 * 60

/** Сколько секунд живут справочные чтения без подписчиков: список касс и границы дней с чеками. */
export const KEEP_DIRECTORY_SECONDS = 10 * 60

/** Миллисекунд в сутках: перевод даты в номер дня при подсчёте длины периода. */
export const MS_PER_DAY = 86_400_000

/** Длина календарного дня `ГГГГ-ММ-ДД` в начале ISO-даты. */
export const DAY_LENGTH = 10
